// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateBodyContainer_container__2BMNt","progressBar":"CreateBodyContainer_progressBar__1V0Aa","progressBarContainer":"CreateBodyContainer_progressBarContainer__150pU"};